import {Constants} from '@/utilities/constants/index.js';

const state = {
  errorDialogIsActive: false,
  errorDialogSeverity: Constants.DIALOG_SEVERITY_ERROR,
  errorDialogMessage: '',
  errorDialogTitle: '',
  errorDialogIconCode: '',
  errorDialogCallback: null,
  errorDialogCallbackParams: null
}
  
const getters = {
  currentErrorDialogIsActive: (state) => state.errorDialogIsActive,
  currentErrorDialogSeverity: (state) => state.errorDialogSeverity,
  currentErrorDialogMessage: (state) => state.errorDialogMessage,
  currentErrorDialogTitle: (state) => state.errorDialogTitle,
  currentErrorDialogIconCode: (state) => state.errorDialogIconCode,
  currentErrorDialogCallback: (state) => state.errorDialogCallback,
  currentErrorDialogCallbackParams: (state) => state.errorDialogCallbackParams
}
  
const actions = {
  activateErrorDialog({ commit }, params) {
    commit('setErrorDialog', {
      activate: true,
      severity: params.severity, 
      message: params.message, 
      title: params.title, 
      icon: params.icon,
      callback: params.callback,
      callbackParams: params.callbackParams
    })
  },
  deactivateErrorDialog({ commit }) {
    commit('setErrorDialog', {
      activate: false
    })
  }
}
  
const mutations = {
  setErrorDialog: (state, params) => {
    state.errorDialogIsActive = params.activate;
    state.errorDialogSeverity = params.severity || Constants.DIALOG_SEVERITY_ERROR,
    state.errorDialogMessage = params.message || 'Something went wrong! Please try again or contact support for further assistance.';
    state.errorDialogTitle = params.title || 'Oops! Something went wrong';
    state.errorDialogIconCode = params.icon || 'warning';
    state.errorDialogCallback = params.callback || null;
    state.errorDialogCallbackParams = params.callbackParams || null;
  }
}
  
export default {
  state,
  getters,
  actions,
  mutations
}
  